import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { Model } from '@socrates/common';

@Directive({
	selector: '[unique-in-list][formControlName],[unique-in-list][formControl],[unique-in-list][ngModel]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: UniqueInListDirectiveValidator, multi: true }
	],
	standalone: false,
})
export class UniqueInListDirectiveValidator implements Validator {
	private _ignoreCase: boolean;

	@Input() private list: Model[];
	@Input() private property: string;
	@Input() private thisid: string;

	@Input('ic')

	get ic(): boolean {
		return this._ignoreCase;
	}
	set ic(newIgnoreCase: boolean) {
		this._ignoreCase = true;
	}

	validate(control: AbstractControl): { [key: string]: any } {

		let currValue: string = control.value;
		if (currValue) {
			if (this.ic) {
				currValue = currValue.toLowerCase();
			}
			if (currValue && currValue.length > 0 && this.list && Array.isArray(this.list) && this.list.length > 0) {
				const model = this.list.find(
					(testModel: Model) => {
						let foundSame = false;
						if (testModel.id !== this.thisid) {
							let value: string = testModel[this.property];
							if (this.ic) {
								value = testModel[this.property].toLowerCase();
							}
							foundSame = value === currValue;
						}
						return foundSame;
					}
				);
				if (model) {
					return { isUnique: true };
				}
			}
		}
		return null;
	}
}
